export default [
  {
    title: 'مدیریت زیره گپ',
    icon: 'bx bx-award',
    children: [
      {
        title: 'گروه های چت',
        route: { name: 'messageGroups' },
        resource: 'HeroManagment',
        action: 'show',
      },
      {
        title: 'کاربران گروه',
        route: { name: 'messageGroupUsers' },
        resource: 'HeroManagment',
        action: 'show',
      },
      {
        title: 'پیام های گزارش شده',
        route: { name: 'messageReports' },
        resource: 'HeroManagment',
        action: 'show',
      },
      {
        title: 'پیام های پین شده',
        route: { name: 'messagePin' },
        resource: 'HeroManagment',
        action: 'show',
      },
     {
        title: ' پیام های زمان بندی شده',
        route: { name: 'scheduleMessage' },
        resource: 'HeroManagment',
        action: 'show',
      },

    ]
  }
]